import React, { useContext } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faAngleLeft } from '@fortawesome/free-solid-svg-icons'
import { AppContext } from '../App'

export default function AppHeader({appHeader}) {
   const { 
      currentStep,
      setCurrentStep,
      linkGoBackTarget,
      setLinkGoBackTarget,
      setAppHeader,
      productOptionsRemoveLast,
      stepsCompleted,
      setStepsCompleted,
      productOptionsSelected,
      setColorValue,
      setChipValue
   } = useContext(AppContext)

   const { productOptions } = productOptionsSelected
   const application = productOptions[1]

   const iconCheck = <FontAwesomeIcon icon={ faCheck } color="#00a8d5" />
   const iconAngleLeft = <FontAwesomeIcon icon={ faAngleLeft } color="#00a8d5" />

   const handleLinkGoBackClick = () => {
      let newLinkTarget, stepString
      // Determine where to set linkGoBackTarget to.        
      if(application.toLowerCase().indexOf('resinous') > -1) {
         switch(linkGoBackTarget.link) {
               case "productTypeSelection": newLinkTarget = "productTypeSelection"; stepString = ""; break
               case "resinousApplicationSelection": newLinkTarget = "productTypeSelection"; stepString = "Step 1"; break // original: What type of product would you like to estimate?
               case "resinousSystemSelection": newLinkTarget = "resinousApplicationSelection"; stepString = "Step 2 of 4"; break
               case "resinousSystemTypeSelection": newLinkTarget = "resinousSystemSelection"; stepString = "Step 3 of 4"; break
               case "NEW ONE": newLinkTarget = "productTypeSelection"; break; default: alert("Target provided does not match. Cannot set linkGoBackTarget")
         }
      }else if(application.toLowerCase().indexOf('adhesive') > -1) {
         switch(linkGoBackTarget.link) {
               case "productTypeSelection": newLinkTarget = "productTypeSelection"; stepString = ""; break // original: What type of product would you like to estimate?
               case "adhesivesProductSelection": newLinkTarget = "productTypeSelection"; stepString = "Step 1 of 2"; break
               case "adhesivesCoverageDetails": newLinkTarget = "adhesivesProductSelection"; stepString = "Step 2 of 2"; break
               case "NEW ONE": newLinkTarget = "productTypeSelection"; break
               default: alert("Target provided does not match. Cannot set linkGoBackTarget")
         }
      }else if(application.toLowerCase().indexOf('grout') > -1) {
         switch(linkGoBackTarget.link) {
               case "productTypeSelection": newLinkTarget = "productTypeSelection"; stepString = ""; break // original: What type of product would you like to estimate?
               case "groutProductSelection": newLinkTarget = "productTypeSelection"; stepString = "Step 1 of 2"; break
               case "groutCoverageDetails": newLinkTarget = "groutProductSelection"; stepString = "Step 2 of 2"; break
               case "NEW ONE": newLinkTarget = "productTypeSelection"; break
               default: alert("Target provided does not match. Cannot set linkGoBackTarget")
         }
      }else if(application.toLowerCase().indexOf('underlayment') > -1) {
         switch(linkGoBackTarget.link) {
               case "productTypeSelection": newLinkTarget = "productTypeSelection"; stepString = ""; break // original: What type of product would you like to estimate?
               case "underlaymentProductSelection": newLinkTarget = "productTypeSelection"; stepString = "Step 1 of 2"; break
               case "underlaymentCoverageDetails": newLinkTarget = "underlaymentProductSelection"; stepString = "Step 2 of 2"; break
               case "NEW ONE": newLinkTarget = "productTypeSelection"; break
               default: alert("Target provided does not match. Cannot set linkGoBackTarget")
         }
      }

      // Update the current step to go one step back.
      setCurrentStep({ step: linkGoBackTarget.link })
      // Set the "Go back" link target to the new target.
      setLinkGoBackTarget({ link: newLinkTarget })
      // Set the appHeader for Step state.
      setAppHeader(stepString)
      // Remove the last item in App state productOptionsSelected.
      productOptionsRemoveLast()
      // Update the steps completed to remove the current step.
      stepsCompleted.pop()
      setStepsCompleted(stepsCompleted)
      // Reset color and chip selections to null
      setColorValue()
      setChipValue()
   }

   const showGoBackLinkOn = [
      'productTypeSelection',
      'resinousQuoteCreated',
      'resinousCoveQuoteCreated',
      'adhesivesQuoteCreated',
      'groutQuoteCreated',
      'underlaymentQuoteCreated',
   ]
   const showHorizontalRuleOn = [
      'productTypeSelection',
      'adhesivesProductSelection',
      'groutProductSelection',
      'underlaymentProductSelection',
      'resinousApplicationSelection',
      'resinousSystemSelection'
   ]
   const showGoBack = showGoBackLinkOn.indexOf(currentStep.step) > -1
    const showHr = showHorizontalRuleOn.indexOf(currentStep.step) > 0
   
   return (
      <div className="row app-header">
         <div className="col-xs-12">
               <h2 className="h3 text-center">{appHeader} { stepsCompleted.indexOf("Provide Coverage Details") > -1 ? iconCheck : null }</h2>
               <div className="link-go-back-wrapper text-center">
                  <a onClick={ handleLinkGoBackClick } href="# " className={ showGoBack ? "link-go-back hidden" : "link-go-back" }>
                     { iconAngleLeft } Go back
                  </a>
               </div>                
         </div>
         <div className={ showHr ? "col-xs-12" : "col-xs-12 hidden" }>
               <hr />
         </div>
      </div>
   )
}


// WEBPACK FOOTER //
// ./src/components/AppHeader.js